import React from 'react';
import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledAlert = styled(Alert)(({ theme, severity }) => ({
  borderRadius: 12,
  backdropFilter: 'blur(8px)',
  backgroundColor: alpha(theme.palette[severity]?.light || theme.palette.success.light, 0.95),
  padding: theme.spacing(1.2, 2),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  border: `1px solid ${alpha(theme.palette[severity]?.main || theme.palette.success.main, 0.1)}`,
  '.MuiAlert-icon': {
    opacity: 0.8,
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
    color: theme.palette[severity]?.main || theme.palette.success.main,
  },
  '.MuiAlert-message': {
    padding: theme.spacing(0.5, 0),
    fontSize: '0.95rem',
    color: theme.palette[severity]?.contrastText || theme.palette.success.contrastText,
  },
  '.MuiAlertTitle-root': {
    fontSize: '0.95rem',
    fontWeight: 600,
    marginBottom: 2,
  }
}));

const CustomSnackbar = ({
  open,
  message,
  title,
  severity = 'success',
  autoHideDuration = 3000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  onClose,
}) => {
  const [isOpen, setIsOpen] = React.useState(open);

  React.useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
    if (onClose) {
      onClose(event, reason);
    }
  };

  const duration = severity === 'error' ? 6000 : autoHideDuration;

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      sx={{ 
        '& .MuiSnackbar-root': {
          transition: 'all 200ms ease-in-out'
        }
      }}
    >
      <StyledAlert
        severity={severity}
        variant="filled"
        elevation={6}
        sx={severity === 'error' ? {
          fontSize: '1rem',
          fontWeight: 600,
          boxShadow: '0 8px 24px rgba(211, 47, 47, 0.4)'
        } : {}}
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </StyledAlert>
    </Snackbar>
  );
};

export default CustomSnackbar;